<template>
  <div id="canvas" v-if="loggedIn" class="gift-choice-page">
    <div v-if="!isCustomHeader || !collectionImage" class="header">
        <img src="https://cdn.shopify.com/s/files/1/1363/8433/files/header_0c9e2d5f-1450-455e-b987-c0b865bcf0f9.svg?v=1683210161"/>
    </div>
    <div class="header custom" v-else>
      <img class="desktop" v-if="collectionImage" :src="collectionImage.src"/>
      <img class="mobile" v-if="collectionImage" :src="collectionImage.alt"/>
      <p v-if="!collectionImage" class="title">{{collectionTitle}}</p>
    </div>
    <div class="main-container">
        <p v-if="!isCustomHeader" class="main-title">We've got some great gifts for you to choose from </p>
        <div class="gifting-header">
          <div style="width: 33.3%;flex-grow: 0;flex-shrink: 0;"></div>
          <div v-for="(step,i) in steps" :key="step" class="header-step" :class="currentStep == i ? 'current' : ''">
            <p class="title">{{ step }}</p>
            <p class="circle"></p>
          </div>
          <div class="header-line"></div>
        </div>
        <div v-if="(products.length > 0)" class="products-container">
          <div v-for="product in products" :key="product.id" class="product-container">
            <div @click="selectDescProduct(product)" :class="product == selectedProduct ? 'selected' : ''" class="product-image-container">
              <img class="info mobile" src="https://cdn.shopify.com/s/files/1/1363/8433/files/info_icon_9b78e5b1-b9be-49ca-826c-b3734c2991c5.svg?v=1683232689"/>
              <img class="main-image" :src="product | getProductImage"/>
              <img v-if="product.images.length > 1" :src="product.images[1].src" class="hover-image" />
              <div class="hover-container">
                <p>TAKE A PEEK</p><img src="https://cdn.shopify.com/s/files/1/1363/8433/files/eyes.svg?v=1683212003"/>
              </div>
            </div>
            <p class="product-title">{{ product.title }}</p>
            <button @click="goCheckout" v-if="(selectedProduct && product.id == selectedProduct.id)" class="happybox-button yellow">Next ></button>
            <button @click="selectProduct(product)" v-else class="happybox-button white">Select</button>
          </div>
        </div>
        <div class="spinner-container" v-else>
          <div class="spinner"></div>
        </div>
        <div class="continue-container" :class="selectedProduct ? 'sticky' : ''">
          <button v-if="!selectedProduct" class="happybox-button gray">Select Your Gift</button>
          <button v-else :disabled="!selectedProduct" @click="goCheckout" class="happybox-button yellow" :class="isLoading ? 'isLoading' : ''">{{ buttonText }}</button>
        </div>
    </div>
    <ProductModal @changevariant="changeVariant" :isLoading="isLoading" @checkout="goCheckout" @closemodal="closeModal" @selectproduct="selectProduct($event)" :product="descProduct" :selectedProduct="selectedProduct" :isCustomHeader="isCustomHeader" v-if="descProduct"/>
  </div>
  <div v-else class="spinner-container" :class="reclaimed ? 'top' : ''">
    <p v-if="invalidToken">Invalid Access</p>
    <div class="reclaimed-container" v-else-if="reclaimed">
      <p class="title">
        <img src="https://cdn.shopify.com/s/files/1/1363/8433/files/sparkle_4a4131fa-65f2-4bcc-afa8-afb2663b6968.svg?v=1646844031"/>
        <span>Great Choice</span>
        <img src="https://cdn.shopify.com/s/files/1/1363/8433/files/sparkle_4a4131fa-65f2-4bcc-afa8-afb2663b6968.svg?v=1646844031"/>
      </p>
      <p class="subtitle">You'll receive updates and tracking info via email!</p>
    </div>
    <div v-else class="loading-container">
      <p>
        If you are having trouble loading this page, please turn off your VPN or company wifi. <br class="desktop"/> Due to IT security restrictions, you may need to open the link on a personal device or forward the email to a personal email address to redeem your gift.<br class="desktop"/>
        If you are still having issues, please reach out to <a href="mailto:orders@happyboxstore.com">orders@happyboxstore.com</a> for immediate assistance.
      </p>
      <div class="spinner"></div>
    </div>
  </div>
</template>

<script>
import confetti from "canvas-confetti";
import axios from "axios";
import ProductModal from "./components/ProductModal.vue";
export default {
    data(){
        return {
            selectedProduct: null,
            products: [],
            loggedIn: false,
            apiUrl: "https://portal.happyboxstore.com:5054",
            giftToken: null,
            invalidToken: null,
            isLoading: false,
            descProduct: null,
            reclaimed: false,
            corporate: null,
            currentStep: 0,
            isCustomHeader: false,
            collectionTitle: "",
            collectionImage: null,
            extraProperties: [],
            x:0,
            y:0,
        }
    },
    components: {
      ProductModal
    },
    methods:{
        selectProduct(product){
          if(this.selectedProduct && this.selectedProduct.id == product.id){
            this.selectedProduct = null;
          }
          else {
            if(this.isCustomHeader &&  this.descProduct == null && (product.variants.length > 1 || this.hasExtraProperties(product))){
              this.selectDescProduct(product);
              return
            }
            confetti({origin:{
              x: this.x
              ,y: this.y
            }});
            this.selectedProduct = product;
          }
        },
        async goCheckout(){
          if(!this.selectedProduct)
            return;
          this.isLoading = true;
          await this.validateToken();
          await this.clearCart();
        },
        async clearCart(){
          await fetch('/cart/clear.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            }
          }).then(response => {
            this.addToCart();
          })
          .catch((error) => {
            console.error('Error:', error);
          });
        },
        async addToCart(){
          fetch('/cart/add.js', {
              method: 'POST',
              headers: {
                  'Content-Type': 'application/json'
              },
              body: JSON.stringify(this.dataToAdd)
          })
          .then(response => {
            localStorage.setItem('_gs-redirect',true);
            localStorage.setItem('gift', true);
            localStorage.removeItem("giftToken");
            location.href = "/checkout"
          })
          .catch((error) => {
              console.error('Error:', error);
          });
        },
        async login(){
          this.giftToken = localStorage.getItem("giftToken");
          if(!this.giftToken){
            this.invalidToken = true;
            return;
          }
          let response = await axios.post(`${this.apiUrl}/giving/giftLogin`,{token: this.giftToken})
          if(response.data){
            response = response.data;
            if(response.error){
              this.invalidToken = true;
              return;
            }
            else if(response.reclaimed){
              this.reclaimed = true;
            }
            else if(response.cancelled){
              this.invalidToken = true;
            }
            else{
              this.products = response.products.map((x) => {
                x.variants = x.variants.filter(y => y.price == "0.00").map((y) => {
                  if(y.inventory_policy == "continue"){
                    y.inventory_quantity = 999;
                  }

                  return y
                })

                return x
              })
              this.corporate = response.corporate;
              this.loggedIn = true;
              this.collectionTitle = response.collection;
              this.collectionImage = response.collection_image;

              await this.$nextTick(() => {});
              let canvas = document.getElementById('canvas');
              canvas.addEventListener('mousemove', this.onMouseMove, false);
            }
          }
        },
        async validateToken(){
          let response = await axios.post(`${this.apiUrl}/giving/giftLogin`,{token: this.giftToken})
          if(response.data){
            response = response.data
            if(response.error || response.cancelled || response.reclaimed){
              location.reload();
            }
          }
          else {
            location.reload();
          }
        },
        selectDescProduct(product){
          this.extraProperties = [];
          this.descProduct = product;
          document.body.style.overflowY = "hidden";
        },
        closeModal(){
          this.descProduct = null;
          document.body.style.overflowY = "scroll";
        },
        hasExtraProperties(product){
          return product.tags.includes("Properties_")
        },
        changeVariant(event){
          if(this.extraProperties.length > 0){
            let index = this.extraProperties.findIndex(x => x.name == event.name);
            if(index > -1){
              this.extraProperties[index].value = event.value;
              return
            }
          }
          this.extraProperties.push(event);
        },
        onMouseMove(e){
          this.x = e.clientX / window.innerWidth;
          this.y = e.clientY / window.innerHeight;
        }
    },
    computed:{
      steps(){
        if(this.products.length == 1){
          return ["CLAIM YOUR GIFT","ADD YOUR ADDRESS"];
        }
        return ["PICK YOUR GIFT","ADD YOUR ADDRESS"];
      },
      dataToAdd(){
        let data = {
          id: this.selectedProduct.variants[0].id,
          quantity: 1,
          properties: {
          }
        }
        if(this.corporate){
          data.properties.Corporate = true;
          data.properties.CorporateName = this.corporate;
          data.properties._corpGift = this.giftToken;
        }
        else {
          data.properties._gift = this.giftToken;
        }
        data.properties._redeem = true;
        let tags = this.selectedProduct.tags.split(",");
        if(tags.find(x => x.includes("Value_"))){
          let valueTag = tags.find(x => x.includes("Value_"));
          data.properties._value = valueTag.split("_")[1];
        }
        if(tags.find(x => x.includes("Dropship_"))){
          let dropshipTag = tags.find(x => x.includes("Dropship_"));
          let dropshipIdTag = tags.find(x => x.includes("DropshipId_"));
          data.properties._Dropship = dropshipTag.split("_")[1];
          data.properties._DropshipId = dropshipIdTag.split("_")[1];
        }
        if(this.extraProperties.length > 0){
          for(let property of this.extraProperties){
            data.properties[property.name] = property.value;
          }
        }
        return data;
      },
      buttonText(){
        return this.isLoading ? "loading..." : "Next"
      },
    },
    mounted(){
      this.login();
      if(location.pathname.includes("custom-choice")){
        this.isCustomHeader = true;
      }
    },
}
</script>

<style>
    #attentive_overlay{
      display: none;
    }

    p,span{
      color: #0F0C38;
      margin: 0;
    }

    .desktop-flex{
        display: flex;
    }

    .desktop{
        display: block;
    }

    .mobile{
        display: none;
    }

    .wiggle{
        width: 100%;
        overflow: hidden;
        position: relative;
    }

    .wiggle img{
        width: 120%;
        height: 100%;
        position: relative;
        left: -10%;
    }

    .gift-choice-page{
        width: 100%;
    }

    .gift-choice-page .header.custom img{
      padding: unset;
      width: 100%;
    }

    .gift-choice-page .header{
      background-color: #f2f6ff;
      display: flex;
      align-items: center;
      justify-content: center;
    }

    .gift-choice-page .header img{
      width: 23%;
      padding: 2% 0%;
    }

  .wiggle.white{
		background: linear-gradient(0deg, white 40%, #eee6ff 60%);
	}

  .happybox-button.orange{
    padding: 1% 10%;
    font-size: 1.5vw;
    border: 1px solid #d9bd47;
  }

  .main-container{
    text-align: center;
    padding-bottom: 5%;
  }

  .main-container .main-title{
    margin-top: 1%;
    font-size: 1.15vw;
    font-weight: 500;
  }

  .next-step{
    font-size: 1.8vw;
    margin: 2% 0%;
  }

  .next-step span,.next-step strong{
    font-style: italic;
    font-family: moret,sans-serif;
  }

  .main-legend{
    text-align: left;
    font-size: 1.6vw;
    padding-bottom: 5%;
  }

  .products-container {
    display: flex;
    justify-content: space-around;
    flex-wrap: wrap;
    width: 100%;
    margin: 3% 0%;
    gap: 30px 15px;
    padding: 0% 15%;
  }

  .product-container {
    width: 23%;
  }

  .product-container .main-image {
    background-color: #f6f6f6;
    width: 100%;
    cursor: pointer;
  }

  .product-container .hover-image {
    background-color: #f6f6f6;
    width: 100%;
    height: 100%;
    object-fit: contain;
    cursor: pointer;
    position: absolute;
    top: 0;
    bottom: 0;
    z-index: 1;
    -webkit-transition: all .35s ease-in-out;
    transition: all .35s ease-in-out;
  }

  .product-image-container:hover .hover-image {
    opacity: 1;
  }

  .product-container .product-title{
    font-size: 1vw;
    margin: 5% 0%;
    font-weight: bold;
    text-align: center;
    line-height: 1.2;
  }

  .product-image-container{
    display: flex;
    flex-direction: column;
    position: relative;
    overflow: hidden;
    width: 100%;
  }

  .product-image-container.selected{
    border: 2px solid #0d0574;
  }

  .hover-container {
    display: flex;
    position: absolute;
    width: 100%;
    bottom: -30%;
    margin: unset;
    -webkit-transition: all .35s ease-in-out;
    transition: all .35s ease-in-out;
    background-color: rgba(225,231,253,0.8);
    align-items: center;
    justify-content: center;
    gap: 5px;
    cursor: pointer;
    z-index: 2;
  }

  .hover-container img{
    width: 10%;
  }

  .hover-container p{
    color: #5A6BA3;
    font-size: 1vw;
    padding: 2% 0%;
    font-weight: bold;
    letter-spacing: 0.2px;
  }

  .product-image-container:hover .hover-container{
    bottom: 0%;
  }

  .product-container .white{
    border: 1px solid #CFCED8 !important;
  }

  .product-container button{
    padding: 4% 9% !important;
  }

  .continue-container button{
    border: 1px solid #CFCED8;
    padding: 1% 10%;
  }

  .happybox-button.white,.happybox-button.purple,.happybox-button.yellow{
    font-size: 1vw;
    padding: 1% 15%;
  }

  .happybox-button.purple:hover{
    background-color: #e6d7fa;
  }

  .slick-slider{
    width: 100%;
  }

  .slick-track {
  display: flex!important;
}

.slick-slide {
  height: inherit!important;
  display: flex!important;
  justify-content: center;
  align-items: center;
  flex-shrink: 0;
}

.slick-slide div{
  width: 100%;
}

.slick-slider {
  margin-bottom: 15px;
}

.slick-arrow:before {
  content: ""!important;
}

  .loading-container{
    width: 100%;
    background-color: white;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
  }

  .loading-container p{
    font-size: 1.15vw;
    color: #0f0c38;
    font-family: "Karla";
    margin-bottom: 2%;
    text-align: center;
  }

  .spinner-container{
    width: 100%;
    background-color: white;
    display: flex;
    align-items: center;
    justify-content: center;
    min-height: 70vh;
  }

  .spinner-container.top{
    align-items: flex-start;
    padding-top: 5%;
  }

  .spinner {
    border: 4px solid rgba(0, 0, 0, 0.3);
    width: 36px;
    height: 36px;
    border-radius: 50%;
    border-left-color: #09f;
    animation: spin 1s ease infinite;
  }

  @keyframes spin {
    0% {
      transform: rotate(0deg);
    }

    100% {
      transform: rotate(360deg);
    }
  }
  .reclaimed-container{
    height: 100%;
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
  }

  .reclaimed-container .title{
    font-size: 6vw;
    font-family: moret;
    font-weight: bold;
    display: flex;
    gap: 30px;
    width: 100%;
    justify-content: center;
  }

  .reclaimed-container .title img{
    width: 3%;
  }

  .reclaimed-container .subtitle{
    font-size: 3vw;
    font-family: 'moret';
    font-weight: 300;
    width: 35%;
    text-align: center;
    line-height: 1.2;
  }

  .gifting-header{
    display: flex;
    align-items: center;
    padding: 2%;
    position: relative;
  }

  .header-step{
    width: 33.3%;
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .header-step .title{
    color: #908FA3;
    font-family: karla;
    font-size: 0.85vw;
    margin: unset;
    font-weight: bold;
  }

  .header-step.current .title{
    color: #2146A7;
  }

  .header-step .circle{
    width: 0.9vw;
    height: 0.9vw;
    opacity: 0.46;
    border: 1.5px solid #0f0c38;
    background-color: white;
    border-radius: 20px;
    margin: unset;
  }

  .header-step.current .circle{
    background-color: #CCDAFF;
    opacity: 1;
    z-index: 1;
  }

  .header-line{
    width: 100%;
    position: absolute;
    left: 0%;
    border-top: 1.5px solid black;
    bottom: 38.5%;
  }

  @media only screen and (max-device-width: 767px){
    .desktop-flex{
      display: none;
    }

    .desktop{
      display: none;
    }

    .mobile{
      display: block;
    }

    .wiggle img{
      width: 100%;
      left: unset;
    }
    
    .gift-choice-page .header .title{
      font-size: 8vw;
    }

    .main-container .main-title{
      display: none;
    }

    .product-container {
      width: 48%;
      margin-bottom: 5%;
    }

    .happybox-button.orange{
      font-size: 3.5vw;
      width: 100%;
      margin-top: 5%;
    }

    .happybox-button.white, .happybox-button.purple,.happybox-button.yellow{
      font-size: 3.5vw;
    }

    .next-step{
      font-size: 5vw;
      margin: 5% 0%;
    }

    .continue-container{
        width: 100%;
        background-color: white;
        display: flex;
    }

    .continue-container.sticky{
      position: fixed;
      bottom: 0%;
      left: 0;
      padding: 5%;
      border-top: 1px solid black;
      align-items: center;
      justify-content: center;
    }

    .continue-container button{
      font-size: 3.5vw;
      width: 100%;
      padding: 2% !important;
      border: unset !important;
    }

    .gifting-header{
      justify-content: center;
    }

    .header-step{
      width: 50%;
    }

    .header-step .title{
      font-size: 3vw;
    }

    .header-step .circle{
      width: 4vw;
      height: 4vw;
    }

    .header-line{
      bottom: 33%;
    }

    .hover-container,.product-container button{
      display: none;
    }

    .product-container .product-title{
      font-size: 3vw;
    }

    .products-container{
      padding: 0% 5%;
      gap: unset;
    }

    .gift-choice-page .header img{
      width: 70%;
    }

    .product-image-container .info{
      width: 15%;
      position: absolute;
      right: 5%;
    }

    .loading-container p{
      font-size: 3vw;
      text-align: center;
    }
  }
  
</style>